







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Message extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly bottom!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly color!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly accent!: boolean;

  get classes() {
    const { bottom, color, accent } = this;
    const result: Array<string> = [];
    if (bottom) result.push('message_bottom');
    if (color) result.push('message_red');
    if (accent) result.push('message_bold');
    return result;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/settings/components/message/Message.vue